import { render, staticRenderFns } from "./Algorithm.vue?vue&type=template&id=6a7577dc&scoped=true&"
import script from "./Algorithm.vue?vue&type=script&lang=js&"
export * from "./Algorithm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7577dc",
  null
  
)

export default component.exports